<template>
    <div>
        <v-row
            v-if="unit === 'imperial'"
            density="compact"
        >
            <v-col>
                <HeightImperialSelectorInput
                    v-model.number="heightIn"
                    name="heightIn"
                    label="Height (ft/in)"
                    variant="outlined"
                    :error="error"
                    :error-messages="errorMessages"
                    @update:model-value="onChange"
                    hide-details="auto"
                ></HeightImperialSelectorInput>
            </v-col>
        </v-row>
        <v-row
            v-if="unit === 'metric'"
            density="compact"
        >
            <v-col>
                <v-text-field
                    v-model.number="heightMm"
                    type="tel"
                    name="heightMm"
                    label="Hight (mm)"
                    :min="1016"
                    :max="2300"
                    variant="outlined"
                    :error="error"
                    :error-messages="errorMessages"
                    hide-details="auto"
                    @update:model-value="onChange"
                ></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts" setup>
    import { isNumber as lo_isNumber } from 'es-toolkit/compat';
    import { convertNumberOrNull } from 'x1-base/utils';
    import HeightImperialSelectorInput from '~/components/controls/HeightImperialSelectorInput/HeightImperialSelectorInput.vue';

    const props = withDefaults(
        defineProps<{
            modelValue: Nilish<number>;
            unit?: 'imperial' | 'metric';
            error?: boolean;
            errorMessages?: string | string[];
        }>(),
        {
            unit: 'metric'
        }
    );

    const emit = defineEmits<{
        'update:modelValue': [value: Nullable<number>];
    }>();

    const heightIn = ref<Nilish<number>>(props.modelValue);
    const heightMm = ref<Nilish<number>>(props.modelValue);
    let isWatcherPaused = false;

    const unWatchUnit = watch(
        () => props.unit,
        (newUnit, oldUnit) => {
            if (oldUnit && newUnit) {
                heightIn.value = null;
                heightMm.value = null;
            }
        },
        {
            immediate: true
        }
    );

    const unWatchModelValue = watch(
        () => props.modelValue,
        (newVal) => {
            if (!isWatcherPaused && lo_isNumber(newVal)) {
                heightIn.value = newVal;
                heightMm.value = newVal;
            }
        },
        {
            immediate: true
        }
    );

    function onChange(value: Nilish<number | string>): void {
        const out = convertNumberOrNull(value);
        setCurrent(out);
    }

    function setCurrent(item: Nullable<number>): void {
        isWatcherPaused = true;
        emit('update:modelValue', item);

        setTimeout(() => {
            isWatcherPaused = false;
        }, 100);
    }

    onBeforeUnmount(() => {
        unWatchUnit();
        unWatchModelValue();
    });
</script>

<style lang="scss"></style>
